import React, { useCallback, useEffect, useRef, useState } from "react";
import { urlVolverAPoliticas } from "./volverAPoliticas";

/* Unsaved edits of a venue form (Políticas) survive the trip to Zoco Chat to manage WhatsApp templates: the link leaves
   the page, and coming back reloads it from the server. The draft lives in sessionStorage (this tab only), is never
   sent to the server, and is applied once when the form of the same venue opens again. Files cannot be serialized,
   so they stay out of it. */

const PREFIJO = "politicas-borrador:";
export const VIGENCIA_BORRADOR_MS = 24 * 60 * 60 * 1000;

const esArchivo = (v) => typeof Blob !== "undefined" && v instanceof Blob;
const claveDe = (id) => `${PREFIJO}${id}`;

export const guardarBorrador = (id, form) => {
  if (!id || !form) return;
  try {
    const datos = Object.fromEntries(
      Object.entries(form).filter(([, v]) => !esArchivo(v) && !(Array.isArray(v) && v.some(esArchivo))),
    );
    window.sessionStorage.setItem(claveDe(id), JSON.stringify({ guardadoEn: Date.now(), datos }));
  } catch {
    /* Storage unavailable or full: the edits are simply not kept. */
  }
};

export const borrarBorrador = (id) => {
  if (!id) return;
  try {
    window.sessionStorage.removeItem(claveDe(id));
  } catch {
    /* Nothing to clear. */
  }
};

/** The fresh draft of the venue, or null. */
export const leerBorrador = (id) => {
  if (!id) return null;
  try {
    const crudo = window.sessionStorage.getItem(claveDe(id));
    if (!crudo) return null;
    const { guardadoEn, datos } = JSON.parse(crudo);
    if (!datos || typeof datos !== "object" || !(Date.now() - guardadoEn < VIGENCIA_BORRADOR_MS)) return null;
    return datos;
  } catch {
    return null;
  }
};

/** `id` is the venue's id (nothing happens without it), `form` its current form values and `restaurar(datos)` merges
    the draft over them. Returns `guardar` for the Chat link, `volver` (the address to come back to, on Políticas) and `recuperado` for the notice. */
export const useBorradorPoliticas = ({ id, form, restaurar }) => {
  const [recuperado, setRecuperado] = useState(false);
  const formRef = useRef(form);
  formRef.current = form;
  const restaurarRef = useRef(restaurar);
  restaurarRef.current = restaurar;

  useEffect(() => {
    const datos = leerBorrador(id);
    if (!datos) return;
    borrarBorrador(id);
    restaurarRef.current(datos);
    setRecuperado(true);
  }, [id]);

  const guardar = useCallback(() => guardarBorrador(id, formRef.current), [id]);
  return { recuperado, guardar, volver: urlVolverAPoliticas(id) };
};

export const AvisoBorrador = ({ visible }) =>
  visible ? (
    <div role="status" className="zr-draft-notice" style={{ background: "#eef6ff", border: "1px solid #b6d4fe", borderRadius: 10, padding: "12px 16px", marginBottom: 24, color: "#1d4f91", fontSize: 13, fontWeight: 600 }}>
      Recuperamos los cambios sin guardar de antes de ir a Zoco Chat. Revisalos y guardá para conservarlos.
    </div>
  ) : null;
